<iw-shared-layout-container-authentication #auth>
  <div class="columns is-tablet container-login">
    <div class="column is-8 has-background-white">
      <section class="section logo pb-2">
        <img *ngIf="auth.isDicom()" ngSrc="./assets/design/logo-gesoft.jpg" height="47" width="200"/>
        <img *ngIf="!auth.isDicom()" src="./assets/design/iw_logo.svg" class="mt-2" style="color:#000; max-height: 20px;"/>
      </section>
      <section class="section pt-0 is-flex is-relative" style="flex-flow: column; height: calc(100% - 80px);">
        <iw-shared-password-lost (onValidationSuccess)="sendEmailVerificationLostPassword($event)" [formHandler]="formHandler" [errorMessage]="errorMessage"
                                 [sentTo]="sentTo"></iw-shared-password-lost>
        <a class="goto-login" routerLink="/login">Zum Login
          <fa-icon [icon]="faSignIn"></fa-icon>
        </a>
      </section>
    </div>
    <div class="column is-4 contact">
      <p class="text-a has-text-white m-5">
            <span *ngIf="auth.isDicom()">
               <b>Fragen?</b><br><br>
            +49 (0)7633 / 95 20 70<br>
            service&#64;dicom-software.de<br><br>



            DICOM Dischinger Computer GmbH<br>
            Im Ebnet 6<br>
            79238 Ehrenkirchen<br>
            </span>
        <span *ngIf="!auth.isDicom()">
                  <b>Fragen?</b><br><br>
           +49 (0)2771 / 87999 50<br>
            info&#64;indenware.de<br><br>
            IndenWare GmbH<br>
            Driedorfstr. 13<br>
            35683 Dillenburg
            </span>
      </p>
    </div>
  </div>

</iw-shared-layout-container-authentication>
